import axiosInstance from "./axios";

export class ArchivoExamenService {
    getArchivos() {
        return axiosInstance
            .get(`/archivo`)
            .then((res) => res.data)
    }

    addArchivo(dto) {
        return axiosInstance
            .post(`/archivo`, dto)
            .then((res) => res.data)
    }

    updateArchivo(dto) {
        return axiosInstance
            .put(`/archivo/${dto._id}`, dto)
            .then((res) => res.data)
    }

    deleteArchivo(id) {
        return axiosInstance
            .delete(`/archivo/${id}`)
            .then((res) => res.data)
    }
}
